export const FAMILIES_GROUP_DESIGNATION = "FAMILIES_GROUP_DESIGNATION";
